import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, } from '@angular/core';
import { NavigationStart, Router, } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Format, } from 'search/models/search-results';
import { AgentOrConceptData, Entity, EntityTypes, GetItRequest, HoldRequest, } from '../../../../entity/models/entity';
import { Cover } from '../../../../models/cover';
import { ISearchData } from '../../../../models/customization';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss'],
})
export class CardHeaderComponent implements OnInit, OnDestroy {
  @Input() public data: AgentOrConceptData;
  @Input() public originalData: Entity;
  @Output() public getIt$ = new EventEmitter<{ item: GetItRequest }>(true);
  @Output() public placeHold$ = new EventEmitter<{ item: HoldRequest }>(true);
  @ViewChild('header', { static: true }) public header: ElementRef;
  @Output() public tableInited = new EventEmitter();

  public agentOrConcept: AgentOrConceptData = null;
  public altText: string;

  public descriptionVisibilityCondition = false;
  public showBiography = false;
  public textInsideDescription: any;
  public sourceDescription: any;
  public fullCardDescriptionUrl = '';

  public formats: Format[];
  public isInnReachSearchAvailable: boolean;
  public searchData: ISearchData;
  public entityTypes = EntityTypes;
  public coverConfig: Cover;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly router: Router,
  ) {}

  public ngOnInit() {
    this.setDescription(this.data);
    this.addSubscriptions();
    this.setAltText();

    this.agentOrConcept = this.data;
    this.showBiography = this.data?.entityType === this.entityTypes.AGENT && this.data?.type === 'person';
    if (this.showBiography) {
      this.coverConfig = this.data.coverConfig;
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private addSubscriptions(): void {
    this.subscriptions.add(this.router.events.pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        setTimeout(() => this.header.nativeElement.focus());
      }),
    );
  }

  private setAltText(): void {
    if (this.data && this.data.entityType) {
      this.altText = this.data.entityType === EntityTypes.FORMAT_GROUP
        ? 'Cover'
        : this.data.title || '';
    }
  }

  private setDescription(data: AgentOrConceptData): void {
    if (data && data.entityType === EntityTypes.CONCEPT) {
      const concept: AgentOrConceptData = data as AgentOrConceptData;
      if (concept.description && concept.description.label) {
        this.descriptionVisibilityCondition = true;
        this.textInsideDescription = concept.description.label;
        this.sourceDescription = concept.description.source;
        this.fullCardDescriptionUrl = concept.description.url;
      }
    }
  }
}
